import React from 'react';
import {
  Td,
  Tr,
  Chip,
  Text,
  TextLink,
  colors,
  Flex,
  Box,
  RiFilePaperLine
} from '@itandi/itandi-bb-ui';
import { FaSquare } from 'react-icons/fa';
import { RiPencilLine } from 'react-icons/ri';
import { DealIndexVendor } from '~/models/Deal';
import { DealTypeChip } from '~/components/common/parts/chip/DealTypeChip';
import { truncate } from '~/utils/StringUtil';
import { PATH as VENDOR_DEAL_PATH } from '~/pages/vendors/deals/[id]';
import { statusColor } from '~/models/Status';

type Props = {
  deal: DealIndexVendor;
  statusNames: { [p: string]: string };
};

export const DealTableSPRow: React.FC<Props> = ({
  deal,
  statusNames
}: Props) => {
  const unread = deal.unreadMessageCount > 0 || deal.displayUnread;
  const unreadChipLabel =
    deal.unreadMessageCount > 0 ? `未読${deal.unreadMessageCount}` : '未読';
  return (
    <Tr>
      <Td textAlign="Left" verticalAlign="Top">
        <Box marginY={2}>
          <Chip
            iconColor={statusColor[deal.status]}
            iconType={FaSquare}
            label={statusNames[deal.status]}
          />
        </Box>
        {unread && (
          <Box marginY={2}>
            <Chip
              background={colors['semantic-negative']}
              borderColor={null}
              label={unreadChipLabel}
              textColor={colors['itandi-white']}
            />
          </Box>
        )}
        {deal.hasTemporaryDealCancel && (
          <Box marginY={2}>
            <Chip
              background={colors['semantic-negative']}
              borderColor={null}
              iconColor={colors['itandi-white']}
              iconType={RiFilePaperLine}
              label="取下申請あり"
              textColor={colors['itandi-white']}
            />
          </Box>
        )}
        {deal.hasRequestEstimation && (
          <Box marginY={2}>
            <Chip
              background={colors['expressive-blue']}
              borderColor={null}
              iconColor={colors['itandi-white']}
              iconType={RiFilePaperLine}
              label="見積申請中"
              textColor={colors['itandi-white']}
            />
          </Box>
        )}
        {deal.hasDraftEstimation && (
          <Box marginY={2}>
            <Chip
              background={colors['expressive-blue']}
              borderColor={null}
              iconColor={colors['itandi-white']}
              iconType={RiPencilLine}
              label="見積編集中"
              textColor={colors['itandi-white']}
            />
          </Box>
        )}
        {deal.hasRequestEstimationByCompany && (
          <Box marginY={2}>
            <Chip
              background={colors['expressive-aqua-dark']}
              borderColor={null}
              iconColor={colors['itandi-white']}
              iconType={RiFilePaperLine}
              label="見積申請あり"
              textColor={colors['itandi-white']}
            />
          </Box>
        )}
      </Td>
      <Td textAlign="Left" verticalAlign="Top">
        <Box>
          <Flex gap={2}>
            <DealTypeChip
              dealSubtype={deal.dealSubtype}
              dealType={deal.dealType}
            />
          </Flex>
        </Box>
        <Box>
          <TextLink
            href={VENDOR_DEAL_PATH(deal.id)}
            target="_blank"
            variant="PrimaryBold"
          >
            {`${truncate(deal.name, 30)} ${deal.roomNumber || ''}`}
          </TextLink>
          <Flex gap={4}>
            <Box>
              <Text color="Sub" display="Block" size="S">
                {truncate(deal.address, 35)}
              </Text>
            </Box>
            {deal.tenantName && (
              <Box>
                <Text color="Sub" display="Block" size="S">
                  {`${truncate(deal.tenantName, 15)} 様`}
                </Text>
              </Box>
            )}
          </Flex>
        </Box>
      </Td>
    </Tr>
  );
};
